import React from 'react';

const TestPage: React.FC = () => {
  return (
    <div style={{ padding: '20px', fontFamily: 'Arial, sans-serif' }}>
      <h1 style={{ color: '#19285c' }}>🎉 React App is Working!</h1>
      <div style={{ background: '#eae8e4', padding: '20px', margin: '20px 0', borderRadius: '10px' }}>
        <h2>✅ Basic Setup Test</h2>
        <p><strong>Vite:</strong> ✅ Running</p>
        <p><strong>React:</strong> ✅ Rendering</p>
        <p><strong>TypeScript:</strong> ✅ Working</p>

        <h3>Environment Variables:</h3>
        <p>Clerk Key: {import.meta.env.VITE_CLERK_PUBLISHABLE_KEY ? '✅ Found' : '❌ Missing'}</p>
        <p>Supabase URL: {import.meta.env.VITE_SUPABASE_URL ? '✅ Found' : '❌ Missing'}</p>
      </div>

      <div style={{ background: '#19285c', color: 'white', padding: '15px', borderRadius: '10px' }}>
        <h3>🔗 Test Links:</h3>
        <a href="/sign-in" style={{ color: '#d4adbb', textDecoration: 'none', margin: '10px' }}>
          → Sign In Page
        </a>
        <br/>
        <a href="/sign-up" style={{ color: '#d4adbb', textDecoration: 'none', margin: '10px' }}>
          → Sign Up Page
        </a>
      </div>
    </div>
  );
};

export default TestPage;